import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenancePrintFormatsComponent } from "./maintenance-print-formats.component";
import { ListPrintFormatsComponent } from "./list-print-formats/list-print-formats.component";
import { CreateEditPrintFormatsComponent } from "./create-edit-print-formats/create-edit-print-formats.component";
import { EditFieldsOfFormatsComponent } from "./edit-fields-of-formats/edit-fields-of-formats.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesPrintFormats: Routes = [
  {
    path: "",
    component: MaintenancePrintFormatsComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListPrintFormatsComponent,
      },
      {
        path: "creacion",
        component: CreateEditPrintFormatsComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: CreateEditPrintFormatsComponent,
        data: {
          operation: "edicion",
        },
      },
      {
        path: "campos/edicion/:id",
        component: EditFieldsOfFormatsComponent,
        data: {
          operation: "edicion",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesPrintFormats)],
  exports: [RouterModule],
})
export class PrintFormatsRoutingModule {}
